'use strict';

var Region = require('region-align');
var assign = require('object-assign');
var React = require('react');
var cloneElement = React.cloneElement;
var getPositionStyle = require('./getSubMenuPositionStyle');

module.exports = function (props, state) {
    var menu = state.menu;

    if (menu && this.didMount) {

        var style = getPositionStyle.call(this, props, state);

        menu = cloneElement(menu, assign({
            ref: 'subMenu',
            subMenu: true,
            parentMenu: this,
            maxHeight: state.subMenuMaxHeight,
            onActivate: this.onSubMenuActivate,
            onInactivate: this.onSubMenuInactivate,
            scrollerProps: props.scrollerProps,
            constrainTo: props.constrainTo,
            expander: props.expander,
            theme: props.theme,
            themes: props.themes || this.constructor.themes
        }, props.itemStyleProps));

        return React.createElement(
            'div',
            { ref: 'subMenuWrap', style: style,
                onMouseEnter: this.handleSubMenuMouseEnter,
                onMouseLeave: this.handleSubMenuMouseLeave
            },
            menu
        );
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-menus/lib/renderSubMenu.js
 ** module id = 182
 ** module chunks = 0
 **/